// parallelReads.js — F13-wave8: execução PARALELA dos tool calls READ-ONLY de
// um mesmo turno (padrão Claude Code: o modelo emite N reads independentes num
// bloco e o harness paga UMA latência, não N). Regras de segurança:
//   • só quando o LOTE INTEIRO é read-only (nenhuma mutante/terminal) e ≥2 calls
//     — qualquer mutante ⇒ null e tudo segue o caminho serial (ordem/aprovação
//     intactas);
//   • o TOOL GATE roda ANTES do prewarm: se QUALQUER call do lote é negada pela
//     policy, o lote inteiro volta pro serial (um read negado jamais executa
//     antes da negação);
//   • o spine consome os resultados NA ORDEM original — todo o bookkeeping
//     (repeat-guard, effects, health) fica intacto.
// @arch:pure-engine — a execução é injetada; nada de window/IPC aqui.

import { MUTATING_TOOLS, TERMINAL_TOOLS } from './toolDescriptors.js';

/** O lote é 100% read-only (tools nativas fora de MUTATING/TERMINAL; extras só
 * quando não-mutantes)? Pure. */
export function isParallelizableBatch(toolCalls, extraByName) {
  if (!Array.isArray(toolCalls) || toolCalls.length < 2) return false;
  return toolCalls.every((tc) => {
    const name = String(tc?.name || '');
    if (!name || MUTATING_TOOLS.has(name) || TERMINAL_TOOLS.has(name)) return false;
    const extra = extraByName?.get?.(name);
    if (extra) return !extra.mutating;
    return true;
  });
}

/**
 * Pré-executa o lote em paralelo → Map(id → Promise<string>), ou null quando o
 * lote não qualifica (mutante presente, <2 calls, ou gate negando qualquer uma).
 * O consumidor dá await por id na ordem original.
 * @param {Array<{id:string,name:string}>} toolCalls
 * @param {Map|null} extraByName
 * @param {{ gateDenies?: (tc:object)=>boolean, execute: (tc:object)=>Promise<string> }} cfg
 */
export function prewarmParallelReads(toolCalls, extraByName, { gateDenies, execute } = {}) {
  if (!isParallelizableBatch(toolCalls, extraByName)) return null;
  if (typeof execute !== 'function') return null;
  if (typeof gateDenies === 'function' && toolCalls.some((tc) => gateDenies(tc))) return null;
  const map = new Map();
  for (const tc of toolCalls) {
    map.set(tc.id, Promise.resolve().then(() => execute(tc)).catch((e) => `Erro: ${e?.message || 'tool falhou'}`));
  }
  return map;
}
